import {useOpenedStateManager} from '@aboutyou/opened-state-manager';
import {useHistory} from '@aboutyou/router';
import {useRef} from 'react';
import {
  SetFiltersWithoutToggleType,
  usePotentialFilters,
} from './usePotentialFilters';

const FLYOUT_FILTER_KEY = 'flyout-filter';

export const useOpenFilterFlyout = () => {
  const {
    open,
    cancel,
    parameter: openedFlyoutSlug,
  } = useOpenedStateManager(FLYOUT_FILTER_KEY);
  const history = useHistory();
  const tempFilters = useRef<SetFiltersWithoutToggleType>([]);
  const {filters: activeFilters, setFiltersWithoutToggle} =
    usePotentialFilters();

  /**
   * sizeGroups filter holds several filters, and we get the values using the second function params "filtersSlugs",
   * for the rest the values are obtained using the param "flyoutSlug"
   */
  const openFilterFlyout =
    (flyoutSlug: string) => (filtersSlugs?: string[]) => {
      const slugs = Array.isArray(filtersSlugs) ? filtersSlugs : [flyoutSlug];
      tempFilters.current = slugs.map(slug => ({
        filterSection: slug,
        filterValues: activeFilters.get(slug),
      }));
      open({parameter: flyoutSlug});
    };

  const submitFilterFlyout = () => {
    tempFilters.current = [];
    // Filter selections apply live via history.replace on the child flyout's
    // pushed entry, and cancel() closes it by popping that entry (ASFE-8284) —
    // which restores the pre-open URL. Submit must keep the selections, so
    // carry the current search over onto the entry the pop lands on. All other
    // close paths (X, hardware back) intentionally revert to the pre-open URL.
    const appliedSearch = history.location.search;
    const unlisten = history.listen((location, action) => {
      unlisten();
      if (action === 'POP' && location.search !== appliedSearch) {
        history.replace({...location, search: appliedSearch});
      }
    });
    cancel();
  };

  const hideFilterFlyout = () => {
    setFiltersWithoutToggle(tempFilters.current);
    tempFilters.current = [];
    cancel();
  };

  return {
    openFilterFlyout,
    hideFilterFlyout,
    submitFilterFlyout,
    openedFlyoutSlug,
  };
};
